var _path;
const _excluded = ["title", "titleId"];
function _extends() { return _extends = Object.assign ? Object.assign.bind() : function (n) { for (var e = 1; e < arguments.length; e++) { var t = arguments[e]; for (var r in t) ({}).hasOwnProperty.call(t, r) && (n[r] = t[r]); } return n; }, _extends.apply(null, arguments); }
function _objectWithoutProperties(e, t) { if (null == e) return {}; var o, r, i = _objectWithoutPropertiesLoose(e, t); if (Object.getOwnPropertySymbols) { var n = Object.getOwnPropertySymbols(e); for (r = 0; r < n.length; r++) o = n[r], -1 === t.indexOf(o) && {}.propertyIsEnumerable.call(e, o) && (i[o] = e[o]); } return i; }
function _objectWithoutPropertiesLoose(r, e) { if (null == r) return {}; var t = {}; for (var n in r) if ({}.hasOwnProperty.call(r, n)) { if (-1 !== e.indexOf(n)) continue; t[n] = r[n]; } return t; }
import * as React from "react";
function SvgMaterialSymbolsMailOutline(_ref, svgRef) {
  let {
      title,
      titleId
    } = _ref,
    props = _objectWithoutProperties(_ref, _excluded);
  return /*#__PURE__*/React.createElement("svg", _extends({
    width: 32,
    height: 32,
    viewBox: "0 0 32 32",
    fill: "none",
    xmlns: "http://www.w3.org/2000/svg",
    ref: svgRef,
    "aria-labelledby": titleId
  }, props), title ? /*#__PURE__*/React.createElement("title", {
    id: titleId
  }, title) : null, _path || (_path = /*#__PURE__*/React.createElement("path", {
    d: "M5.33317 26.6666C4.59984 26.6666 3.97228 26.4057 3.4505 25.8839C2.92873 25.3621 2.66739 24.7341 2.6665 23.9999V7.99992C2.6665 7.26659 2.92784 6.63903 3.4505 6.11725C3.97317 5.59547 4.60073 5.33414 5.33317 5.33325H26.6665C27.3998 5.33325 28.0278 5.59459 28.5505 6.11725C29.0732 6.63992 29.3341 7.26747 29.3332 7.99992V23.9999C29.3332 24.7333 29.0723 25.3613 28.5505 25.8839C28.0287 26.4066 27.4007 26.6675 26.6665 26.6666H5.33317ZM15.9998 17.3333L5.33317 10.6666V23.9999H26.6665V10.6666L15.9998 17.3333ZM15.9998 14.6666L26.6665 7.99992H5.33317L15.9998 14.6666ZM5.33317 10.6666V7.99992V23.9999V10.6666Z",
    fill: "white"
  })));
}
const ForwardRef = /*#__PURE__*/React.forwardRef(SvgMaterialSymbolsMailOutline);
export default __webpack_public_path__ + "static/media/material-symbols_mail-outline.a1a18863f8e4446e4dc36706968b8750.svg";
export { ForwardRef as ReactComponent };